export default {"src":"/_next/static/media/icon_star.676306d5.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};